import React from "react";
import {
  BooleanInput,
  TabbedForm,
  FormTab,
  EditController,
  EditView,
  AutocompleteInput,
  SelectInput,
  FormDataConsumer,
  ReferenceInput,
  ReferenceField,
  SaveButton,
  Toolbar,
  DeleteButton,
  TextField,
  TextInput
} from "react-admin";
import FootballFormTab from "./FootballFormTab";
import GirlsVolleyballFormTab from "./GirlsVolleyballFormTab";
import BasketballFormTab from "./BasketballFormTab";
import SoccerFormTab from "./SoccerFormTab";
import BaseballFormTab from "./BaseballFormTab";
import SeasonTeamPlayersEdit from "./seasonTeamPlayers/SeasonTeamPlayersEdit";
import SeasonTeamTitle from "./SeasonTeamTitle";
import { useFormState } from "react-final-form";
import { getModifiedPlayerData } from "./data";

const SeasonTeamEdit = (props) => {
  const CustomToolbar = function(props) {
    const { modified } = useFormState();

    const transformData = (data) => ({
      ...data,
      modifiedPlayerData: getModifiedPlayerData(modified, data)
    });

    const redirectPath = `/teams/${props.record.team.id}/show/1`;
    return (
      <Toolbar {...props}>
        <SaveButton transform={transformData} redirect={false} />
        <DeleteButton undoable={false} redirect={redirectPath} />
      </Toolbar>
    );
  };

  function districtOptionText(r) {
    if (!r.label)
      return (
        [
          r.leagueCode,
          r.conferenceCode,
          r.divisionCode,
          r.regionCode,
          r.districtCode
        ].join(" ") +
        "(" +
        r.id +
        ")"
      );
    return (
      [
        r.leagueCode,
        r.conferenceCode,
        r.divisionCode,
        r.regionCode,
        r.districtCode
      ].join(" ") +
      "(" +
      r.label +
      ", " +
      r.id +
      ")"
    );
  }

  return (
    <EditController undoable={false} {...props}>
      {(controllerProps) => (
        <EditView
          undoable={false}
          {...props}
          {...controllerProps}
          title={<SeasonTeamTitle />}
        >
          <TabbedForm toolbar={<CustomToolbar />}>
            <FormTab label="summary">
              <TextField source="id" />
              <ReferenceField label="Team" source="team.id" reference="teams">
                <TextField source="name" />
              </ReferenceField>
              <TextField source="sportCode" />
              <TextField source="seasonCode" />
              <TextInput source="coachName" />
              <TextInput source="coachEmail" />
              <TextInput source="coachUpdated" />
              <BooleanInput source="isInArea" />
              <SelectInput
                source="rollupMode"
                choices={[
                  { id: "AUTOMATIC", name: "AUTOMATIC" },
                  { id: "MANUAL", name: "MANUAL" }
                ]}
              />
              <FormDataConsumer>
                {({ formData, ...rest }) => (
                  <ReferenceInput
                    perPage={9999}
                    label="District"
                    allowEmpty
                    source="district.id"
                    reference="districts"
                    filter={{
                      sportCode: formData.sportCode,
                      seasonCode: formData.seasonCode
                    }}
                  >
                    <AutocompleteInput
                      optionValue="id"
                      optionText={districtOptionText}
                    />
                  </ReferenceInput>
                )}
              </FormDataConsumer>
            </FormTab>
            {controllerProps.record &&
              controllerProps.record.sportCode === "girls-volleyball" && (
                <FormTab label="volleyball">
                  <GirlsVolleyballFormTab />
                </FormTab>
              )}
            {controllerProps.record &&
              controllerProps.record.sportCode === "football" && (
                <FormTab label="football">
                  <FootballFormTab />
                </FormTab>
              )}
            {controllerProps.record &&
              controllerProps.record.sportCode === "girls-basketball" && (
                <FormTab label="girls-basketball">
                  <BasketballFormTab />
                </FormTab>
              )}
            {controllerProps.record &&
              controllerProps.record.sportCode === "boys-basketball" && (
                <FormTab label="boys-basketball">
                  <BasketballFormTab />
                </FormTab>
              )}
            {controllerProps.record &&
              controllerProps.record.sportCode === "girls-soccer" && (
                <FormTab label="girls-soccer">
                  <SoccerFormTab />
                </FormTab>
              )}
            {controllerProps.record &&
              controllerProps.record.sportCode === "boys-soccer" && (
                <FormTab label="boys-soccer">
                  <SoccerFormTab />
                </FormTab>
              )}
            {controllerProps.record &&
              controllerProps.record.sportCode === "softball" && (
                <FormTab label="softball">
                  <BaseballFormTab />
                </FormTab>
              )}
            {controllerProps.record &&
              controllerProps.record.sportCode === "baseball" && (
                <FormTab label="baseball">
                  <BaseballFormTab />
                </FormTab>
              )}
            <FormTab label="players">
              <SeasonTeamPlayersEdit />
            </FormTab>
          </TabbedForm>
        </EditView>
      )}
    </EditController>
  );
};

export default SeasonTeamEdit;
